import { useMemo } from 'react';

/**
 * Use this hook to memo an array whose reference shouldn't change if its values are the same.
 *
 * @param array - Array to memo.
 * @returns Array.
 */
export const useMemoArray = <T extends unknown[]>(array: T): T =>
  // biome-ignore lint/correctness/useExhaustiveDependencies: JSON.stringify is the intentional deep-compare dependency
  useMemo(() => array, [JSON.stringify(array)]);
